import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';

export default abstract class CalendarBulkBaseRoute extends PermittedRoute {
  permission = 'calendar.rate_edit';
}
